import React, { useEffect, useState } from 'react'
import BackgroundImage from '../../../assets/early/images/BackgroundImage.png'
import { useTranslation } from 'react-i18next'
import Header from './Header'
import ConfirmFooter from './ConfirmFooter'

import AnimalEmotionButton from './AnimalEmotionButton'
import ConfirmEmotionModal from '../modals/ConfirmEmotionModal'
import ToastEmotionModal from '../modals/ToastEmotionModal'
import { useHistory, useLocation } from 'react-router-dom'
import { emotions_list } from '../constants/Constants'
import { getById } from '../../../server/server'
import { useQuery } from '../../../utils/util'
import '../../../styles/early/earlyMotion.css'

function StudentSelectEmotionScreen() {
    const query = useQuery()
    const studentId = query.get('id')
    const location = useLocation()
    let history = useHistory()
    const [currentStudent, setCurrentStudent] = useState(location.state?.student ?? {})
    const { t } = useTranslation()
    const [selectedEmotion, setSelectedEmotion] = useState(null)
    const [confirmModalVisible, setConfirmModalVisible] = useState(false)
    const [toastModalVisible, setToastModalVisible] = useState(false)

    useEffect(() => {
        getStudentInfo()
    }, [])

    const getStudentInfo = async () => {
        const resp = await getById({ collection: 'users', id: studentId })
        if (resp.status == 200) {
            setCurrentStudent(resp.data)
        }
    }

    const selectEmotion = (emotion) => {
        setSelectedEmotion(emotion == selectedEmotion ? null : emotion)
    }

    const acceptConfirmation = () => {
        setConfirmModalVisible(false)
        setTimeout(() => {
            setToastModalVisible(true)
        }, 400)
    }

    const onAcceptToast = () => {
        setToastModalVisible(false)
        setTimeout(() => {
            history.goBack()
        }, 400)
    }

    const cancelConfirmation = () => {
        setConfirmModalVisible(false)
        setSelectedEmotion(null)
    }

    const pressConfirm = () => {
        setConfirmModalVisible(true)
    }

    return (
        <div className="grid grid-cols-1">
            <div className="w-full flex flex-col h-screen bg-cover bg-center bg-no-repeat em-screen" style={{ backgroundImage: `url(${BackgroundImage})` }}>
                <Header text={t('Get Back')} />
                <div className="flex-1 items-center justify-center flex flex-col pb-[10%]">
                    <div className="flex items-center justify-center mt-[25px]">
                        <p className="text-[48px] leading-[62px] font-bold text-[#FDDF6D] text-center w-[955px] em-title-in">
                            {t('Which image best describes how you’re feeling right now?')}
                        </p>
                    </div>
                    <div className={`grid grid-cols-6 gap-[40px] mt-[50px] pr-3 em-stagger em-stagger-pop em-emotions ${selectedEmotion ? 'em-emotions--chosen' : ''}`}>
                        {emotions_list.map((item, index) => (
                            <AnimalEmotionButton animal={currentStudent?.animal} emotion={item} onClick={selectEmotion} isSelected={selectedEmotion === item} />
                        ))}
                    </div>
                </div>
                <ConfirmFooter showConfirm={!!selectedEmotion} pressConfirm={pressConfirm} />
                {!!selectedEmotion && (
                    <ConfirmEmotionModal
                        modalVisible={confirmModalVisible}
                        onCancel={cancelConfirmation}
                        onConfirm={acceptConfirmation}
                        emotion={selectedEmotion}
                        student={currentStudent}
                        animal={currentStudent?.animal ?? 'tiger'}
                    />
                )}
                {!!selectedEmotion && (
                    <ToastEmotionModal modalVisible={toastModalVisible} onConfirm={onAcceptToast} emotion={selectedEmotion} animal={currentStudent?.animal ?? 'tiger'} />
                )}
            </div>
        </div>
    )
}

export default StudentSelectEmotionScreen
